import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type CreateImportResponse = {
   externalTrainingModuleImportId: number;
};

export async function createExternalTrainingModuleImport(
   type: 'URL' | 'FILE_UPLOAD',
   sourceName: string,
   allowDuplicateSourceName: boolean = false,
   common: CommonRequestOptions = {}
): Promise<CreateImportResponse> {
   return makeRequest('post', `/external-training-modules/imports`, {
      ...common,
      body: {
         type,
         sourceName,
         allowDuplicateSourceName,
      },
   });
}

export type DuplicateSourceNameError = {
   code: 'external_training_modules.duplicate_source_name';
   message: string;
   external_training_moduleid: number;
};

export function isDuplicateSourceNameError(error: any): error is DuplicateSourceNameError {
   return error && error.code === 'external_training_modules.duplicate_source_name';
}
